import React from 'react';
import NavigationBar from './NavigationBar';
import MenuSearchAndFilter from './common/MenuSearchAndFilter';
import Globalize from '../actions/languages/Globalize';

const Greetings = (props) => {

  return (
    <div id="welcome-screen">
      {/* <NavigationBar loggedStatus={true} user={props.user} /> */}
      <div className="index-page">
        <h4 className="text-center margin-zero">
          {Globalize.getString('welcome_string')} <span className="text-bold text-primary">{props?.user?.email}</span>
        </h4>
        <div className="index-page-links">
          <MenuSearchAndFilter userRoles={props.user_roles} {...props} />
        </div>
      </div>
    </div>
  );
};


export default Greetings;
